import React, { useEffect, useState } from "react";
import {
    Card,
    Row,
    Col,
    Tag,
    Descriptions,
    Avatar,
    Space,
    Typography,
    Empty,
    Form,
    Button,
    DatePicker,
} from "antd";
import {
    UserOutlined,
    MoneyCollectFilled,
} from "@ant-design/icons";
import CustomerDetails from "../Enquiry/CustomerDetails";
import { EnquiryService } from "../../../Services/Manage/EnquiryService";
import dayjs from "dayjs";

const { Title, Text } = Typography;

const ListEqData = ({ data, handleGetCustomerDat, form, quteData }) => {
    const [customerData, setCustomerData] = useState([]);


    // console.log("++++++", customerData);


    // useEffect(()=>{
    //     getCustomerData(quteData?.qu_no);
    // },[quteData])

    // Guard clause: If no data
    if (!data || (Array.isArray(data) && data.length === 0) || Object.keys(data).length === 0) {
        return (
            <div >
                {/* <Empty description="Please select enquiry" /> */}
                <Form
                    form={form}
                    layout="vertical"
                >
                    <CustomerDetails customerData={customerData} />

                    <Button
                        type="primary"
                        size="large"
                        onClick={() => form.submit()}
                        style={{ display: "none" }}
                    >
                        Save
                    </Button>
                </Form>
            </div>
        );
    }


    const formatDate = (dateString) =>
        new Date(dateString).toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });

    const formatCurrency = (amount, currency) =>
        new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency || "USD",
        }).format(amount);

    return (
        <div>
            <Descriptions
                column={{ xs: 1, sm: 2, lg: 2 }}

                size="middle"
                title={
                    <div>
                        <Row justify="space-between" align="middle">
                            <Col>
                                <Text style={{ fontSize: 20 }} strong>
                                    Enquiry No.: {data.eq_id}
                                </Text>
                            </Col>

                            {data.qu_no && (
                                <Col>
                                    <Text style={{ fontSize: 20 }} strong>
                                        Quotation No.: {data.qu_no}
                                    </Text>
                                </Col>
                            )}
                        </Row>

                        <div style={{ marginTop: 4 }}>
                            <Space size="small">
                                <Avatar size={20} icon={<UserOutlined />} />
                                <Text type="secondary" style={{ fontSize: 16 }}>
                                    {data.added_by}
                                </Text>
                                <Text type="secondary" style={{ fontSize: 16 }}>
                                    - {formatDate(data.eq_date)}
                                </Text>
                            </Space>
                        </div>
                    </div>
                }
            >
                <Descriptions.Item label="Service Name">
                    <Text strong>{data.service_name}</Text>
                </Descriptions.Item>

                <Descriptions.Item label="Service Type">
                    <Text>{data.type_name}</Text>
                </Descriptions.Item>

                <Descriptions.Item label="Source">
                    <Tag
                        style={{
                            fontSize: "16px",
                            padding: "6px 12px",
                            borderRadius: "8px",
                        }}
                        color="blue">{data.eq_source}</Tag>
                </Descriptions.Item>

                <Descriptions.Item label="Description" span={2}>
                    <Text>{data.eq_description}</Text>
                </Descriptions.Item>

                <Descriptions.Item label="Note" span={2}>
                    <Text italic>{data.note || "No additional notes"}</Text>
                </Descriptions.Item>

                <Descriptions.Item
                    label={
                        <Space>
                            Total Amount
                        </Space>
                    }
                    span={2}
                >
                    <Title level={2} style={{ color: "#142f06ff", margin: 0 }}>
                        {formatCurrency(data.total_amount, data.currency)}
                    </Title>
                </Descriptions.Item>

                <Descriptions.Item label="Currency">
                    <Tag
                        color="red"
                        style={{
                            fontSize: "16px",
                            padding: "6px 12px",
                            borderRadius: "8px",
                        }}
                    >
                        {data.currency}
                    </Tag>
                </Descriptions.Item>

                <Descriptions.Item label="Customer Name">
                    <Text strong>{data.name}</Text>
                </Descriptions.Item>

                <Descriptions.Item label="Customer Mobile No.">
                    <Text>{data.mobile_no}</Text>
                </Descriptions.Item>

                <Descriptions.Item label="Customer Address">
                    {data.address}
                </Descriptions.Item>
            </Descriptions>
        </div>
    );
};

export default ListEqData;
